<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16mghJJ/tc-custom/9781439666951.jpg?1705026047075" alt="This image is the cover for the book Kansas Tycoon Emerson Carey"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kansas Tycoon Emerson Carey
      </h1>
      <p class="bookDescription body article font2">
        <p>"I've seen a fly make a bull switch his tail" is a homespun quip attributed to Emerson Carey, the powerful salt magnate of Hutchinson, Kansas. True or not, the quote epitomizes the fearless and tenacious character of the legend who became Reno County's benefactor. Young, awestruck Carey arrived in boomtown 1880s Hutchinson and went on to create an immense empire. Coal, ice, salt, strawboard, egg cases, bags, soda ash and streetcars--he presided over it all. From Carey's sleeping in a coal yard with a quarter in his pocket to the founding of the exclusive Willowbrook community and attaining a net worth of more than $15 million, authors Lynn Ledeboer and Myron Marcotte relate the epic story.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lynn Ledeboer, Myron Marcotte, Michael Carey
      </h2>
      
      <p class="authorDescription body article">Lynn is the curator for the Reno County Historical Society. She works with artifacts, creates exhibits and wrote articles for and edited the society's journal, Legacy. Lynn and husband, Dan, have one son and live in Hutchinson with their dog, Tilly.<br><br>Myron Marcotte started working for the Carey Salt Company at the mine in 1975 at the age of eighteen. He is a lifelong resident of Hutchinson, working at Strataca salt museum as a mine specialist. Married to Connie with two adult sons and a Yorkie named Mack.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42b7edb6